import { Link } from 'react-router-dom'
import { useListaDeOs } from '../../../api/queries/ordensDeServico'
import { CampoDeSelecao } from '../../../components/campos'
import { reais } from '../../../lib/dinheiro'
import { OS } from '../../ordens-servico/textosDaOs'

/**
 * A ordem de serviço a que o valor faturado se refere.
 *
 * **É procedência, não base de cálculo.** Apontar a ordem não muda o desconto: ele continua
 * incidindo sobre um valor único do mês, com um teto único de 10% (decisão do dono, 26/08/2026). O
 * que se ganha é a resposta a "de onde veio este número", que hoje só existe em prosa no campo de
 * fundamento — e prosa não se confere contra o documento.
 *
 * **Opcional de propósito.** As competências anteriores à existência do registro de ordens não têm
 * o que apontar, e obrigar a escolha impediria lançar o valor de um mês cuja ordem ninguém
 * registrou ainda. Sem ordem escolhida, o fundamento em texto continua sendo a procedência.
 *
 * A lista traz só as ordens do mês e sem as revogadas: o servidor recusa as duas coisas
 * (`OS_DE_OUTRA_COMPETENCIA`, `OS_REVOGADA`), e oferecer o que ele vai recusar é ensinar o erro.
 *
 * @param props a competência, a ordem escolhida e o que fazer ao trocar
 * @returns o campo de escolha, ou o aviso de que não há ordem registrada no mês
 */
export function EscolhaDaOs({
  competencia,
  escolhida,
  aoEscolher,
}: {
  competencia: string
  escolhida: number | null
  aoEscolher: (id: number | null) => void
}) {
  const { data: pagina, isPending } = useListaDeOs({ competencia, regime: '', situacao: '', pagina: 1 })
  const disponiveis = (pagina?.conteudo ?? []).filter((ordem) => !ordem.revogada)

  if (isPending) {
    return null
  }

  if (disponiveis.length === 0) {
    return (
      <p className="text-sm text-slate-600">
        Nenhuma ordem de serviço registrada em {competencia}.{' '}
        <Link to="/ordens-servico" className="text-niteroi-700 underline underline-offset-2">
          {OS.titulo}
        </Link>
      </p>
    )
  }

  return (
    <CampoDeSelecao
      rotulo="Ordem de serviço a que este valor se refere"
      ajuda={OS.osEProcedencia}
      value={escolhida == null ? '' : String(escolhida)}
      onChange={(evento) => aoEscolher(evento.target.value === '' ? null : Number(evento.target.value))}
    >
      <option value="">Não informar</option>
      {disponiveis.map((ordem) => (
        <option key={ordem.id} value={ordem.id}>
          {ordem.numero}
          {ordem.numeroExterno ? ` · ${ordem.numeroExterno}` : ''} · {reais(ordem.valorTotal)}
        </option>
      ))}
    </CampoDeSelecao>
  )
}
